import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, MessageCircleIcon } from 'lucide-react';
const blockVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function MechanismSection() {
  return <section className="w-full py-16 md:py-24 px-6" style={{
    backgroundColor: 'var(--light-navy)'
  }} data-id="element-40">
      <div className="max-w-2xl mx-auto" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="mb-14" data-id="element-42">
          <h2 className="font-serif text-2xl md:text-3xl mb-3" style={{
          color: 'var(--navy)'
        }} data-id="element-43">
            El mecanismo: por qué esto{' '}
            <span className="relative inline-block" data-id="element-44">
              sí funciona
              <span className="absolute bottom-0 left-0 w-full h-0.5 rounded-full" style={{
              backgroundColor: 'var(--gold)'
            }} data-id="element-45" />
            </span>
          </h2>
          <p className="text-base md:text-lg" style={{
          color: 'var(--charcoal)',
          opacity: 0.75,
          lineHeight: '1.7'
        }} data-id="element-46">
            Este reset usa 3 piezas que se apoyan entre sí:
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-47">
          {/* Block 1: Sistema 3-Cuentas */}
          <motion.div variants={blockVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} className="rounded-2xl p-8 md:p-10" style={{
          backgroundColor: 'white',
          border: '1px solid rgba(200, 164, 92, 0.25)'
        }} data-id="element-48">
            <div className="flex items-center gap-3 mb-6" data-id="element-49">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold" style={{
              backgroundColor: 'var(--navy)',
              color: 'var(--gold)'
            }} data-id="element-50">
                1
              </span>
              <h3 className="font-serif text-xl md:text-2xl" style={{
              color: 'var(--navy)'
            }} data-id="element-51">
                Sistema 3‑Cuentas
              </h3>
            </div>

            <p className="text-base mb-8" style={{
            color: 'var(--charcoal)',
            lineHeight: '1.7'
          }} data-id="element-52">
              Tu dinero deja de mezclarse. Empieza a tener "contenedores" con
              propósito.
            </p>

            {/* Visual: 3 Buckets */}
            <div className="grid grid-cols-3 gap-3 md:gap-4" data-id="element-53">
              <div className="text-center" data-id="element-54">
                <div className="rounded-xl py-6 px-3 mb-3" style={{
                backgroundColor: 'var(--navy)'
              }} data-id="element-55">
                  <span className="text-2xl md:text-3xl" data-id="element-56">🏠</span>
                  <p className="text-xs md:text-sm font-bold mt-2" style={{
                  color: 'var(--gold)'
                }} data-id="element-57">
                    Bills
                  </p>
                </div>
                <p className="text-xs md:text-sm" style={{
                color: 'var(--charcoal)',
                opacity: 0.7,
                lineHeight: '1.5'
              }} data-id="element-58">
                  Lo que sí o sí va a pasar
                </p>
              </div>

              <div className="text-center" data-id="element-59">
                <div className="rounded-xl py-6 px-3 mb-3" style={{
                backgroundColor: 'var(--navy)'
              }} data-id="element-60">
                  <span className="text-2xl md:text-3xl" data-id="element-61">🛒</span>
                  <p className="text-xs md:text-sm font-bold mt-2" style={{
                  color: 'var(--gold)'
                }} data-id="element-62">
                    Vida
                  </p>
                </div>
                <p className="text-xs md:text-sm" style={{
                color: 'var(--charcoal)',
                opacity: 0.7,
                lineHeight: '1.5'
              }} data-id="element-63">
                  Lo cotidiano, controlado por semana
                </p>
              </div>

              <div className="text-center" data-id="element-64">
                <div className="rounded-xl py-6 px-3 mb-3" style={{
                backgroundColor: 'var(--navy)'
              }} data-id="element-65">
                  <span className="text-2xl md:text-3xl" data-id="element-66">⚔️</span>
                  <p className="text-xs md:text-sm font-bold mt-2" style={{
                  color: 'var(--gold)'
                }} data-id="element-67">
                    Deuda
                  </p>
                </div>
                <p className="text-xs md:text-sm" style={{
                color: 'var(--charcoal)',
                opacity: 0.7,
                lineHeight: '1.5'
              }} data-id="element-68">
                  El ataque — progreso visible
                </p>
              </div>
            </div>
          </motion.div>

          {/* Block 2: Barreras Anti-Impulso */}
          <motion.div variants={blockVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} className="rounded-2xl p-8 md:p-10" style={{
          backgroundColor: 'white',
          border: '1px solid rgba(27, 42, 74, 0.08)'
        }} data-id="element-69">
            <div className="flex items-center gap-3 mb-6" data-id="element-70">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold" style={{
              backgroundColor: 'var(--navy)',
              color: 'var(--gold)'
            }} data-id="element-71">
                2
              </span>
              <h3 className="font-serif text-xl md:text-2xl" style={{
              color: 'var(--navy)'
            }} data-id="element-72">
                Barreras Anti‑Impulso
              </h3>
            </div>

            <p className="text-base mb-6" style={{
            color: 'var(--charcoal)',
            lineHeight: '1.7'
          }} data-id="element-73">
              No peleas contra el impulso. Le pones obstáculos.
            </p>

            <div className="flex items-start gap-4 mb-6" data-id="element-74">
              <ShieldIcon className="w-8 h-8 flex-shrink-0 mt-1" style={{
              color: 'var(--gold)'
            }} data-id="element-75" />
              <p className="text-sm" style={{
              color: 'var(--charcoal)',
              opacity: 0.7,
              lineHeight: '1.6'
            }} data-id="element-76">
                Cosas simples que te "salvan" cuando estás cansada/o.
              </p>
            </div>

            <ul className="space-y-3" data-id="element-77">
              <li className="flex items-center gap-3" data-id="element-78">
                <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
                backgroundColor: 'var(--gold)'
              }} data-id="element-79" />
                <span className="text-base" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.7'
              }} data-id="element-80">
                  <strong style={{
                  color: 'var(--navy)'
                }} data-id="element-81">
                    Regla 24h
                  </strong>{' '}
                  — espera antes de comprar
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-82">
                <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
                backgroundColor: 'var(--gold)'
              }} data-id="element-83" />
                <span className="text-base" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.7'
              }} data-id="element-84">
                  <strong style={{
                  color: 'var(--navy)'
                }} data-id="element-85">
                    Quitar tarjetas guardadas
                  </strong>{' '}
                  — fricción real
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-86">
                <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{
                backgroundColor: 'var(--gold)'
              }} data-id="element-87" />
                <span className="text-base" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.7'
              }} data-id="element-88">
                  <strong style={{
                  color: 'var(--navy)'
                }} data-id="element-89">
                    Bloquear la hora peligrosa
                  </strong>{' '}
                  — protege tu momento débil
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Block 3: Loud Budget */}
          <motion.div variants={blockVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} className="rounded-2xl p-8 md:p-10" style={{
          backgroundColor: 'white',
          border: '1px solid rgba(27, 42, 74, 0.08)'
        }} data-id="element-90">
            <div className="flex items-center gap-3 mb-6" data-id="element-91">
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold" style={{
              backgroundColor: 'var(--navy)',
              color: 'var(--gold)'
            }} data-id="element-92">
                3
              </span>
              <h3 className="font-serif text-xl md:text-2xl" style={{
              color: 'var(--navy)'
            }} data-id="element-93">
                Loud Budget
              </h3>
            </div>

            <div className="flex items-start gap-4 mb-4" data-id="element-94">
              <MessageCircleIcon className="w-8 h-8 flex-shrink-0 mt-1" style={{
              color: 'var(--gold)'
            }} data-id="element-95" />
              <div data-id="element-96">
                <p className="text-base mb-3" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.7'
              }} data-id="element-97">
                  El dinero se rompe en silencio.
                </p>
                <p className="text-base" style={{
                color: 'var(--charcoal)',
                lineHeight: '1.7'
              }} data-id="element-98">
                  Aquí tienes frases cortas para poner límites sin culpa, sin
                  justificarte, sin pelear.
                </p>
              </div>
            </div>

            {/* Example speech bubbles */}
            <div className="mt-6 space-y-3 pl-4 md:pl-12" data-id="element-99">
              <div className="inline-block px-4 py-2.5 rounded-2xl rounded-bl-sm text-sm" style={{
              backgroundColor: 'var(--cream)',
              color: 'var(--navy)',
              lineHeight: '1.5'
            }} data-id="element-100">
                "Ahora no puedo, ya tengo mi presupuesto asignado."
              </div>
              <div className="inline-block px-4 py-2.5 rounded-2xl rounded-bl-sm text-sm" style={{
              backgroundColor: 'var(--cream)',
              color: 'var(--navy)',
              lineHeight: '1.5'
            }} data-id="element-101">
                "Suena bien, pero este mes no está en mi plan."
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}